import { render } from 'preact';
import { App } from './app';
import { installI18n } from './lib/i18n';

// The language is the address: /courts is Thai, /en/courts is English. This has to run before the first
// render, because it installs the hook that translates strings on their way into the DOM.
installI18n(window.location.pathname);

const root = document.getElementById('app');
if (root) {
  /*
   * The server writes a plain-HTML version of this page into #app before sending it (server/lib/seo.ts):
   * it is what crawlers that do not run JavaScript read, and what a person sees for the moment before
   * this bundle arrives. Preact renders alongside it rather than over it, so it is taken out by hand the
   * instant the app is on screen — otherwise the page would show, and Google would index, both copies.
   */
  const ssr = root.querySelector('#ssr-content');
  render(<App />, root);
  ssr?.remove();
}
